import React, { useState, useRef, useEffect } from 'react';
import styles from './NewsletterForm.module.css';
import sendNewsletter from '../../API/sendNewsletter';

const NewsletterForm = () => {
  const [subject, setSubject] = useState('');
  const [htmlContent, setHtmlContent] = useState('');
  const [isSending, setIsSending] = useState(false);
  const [responseMessage, setResponseMessage] = useState('');
  const [responseType, setResponseType] = useState('');
  const iframeRef = useRef(null);

  useEffect(() => {
    updatePreview(htmlContent);
  }, [htmlContent]);

  const handleSubjectChange = (e) => {
    setSubject(e.target.value);
  };

  const handleHtmlContentChange = (e) => {
    setHtmlContent(e.target.value);
  };

  const updatePreview = (content) => {
    if (iframeRef.current) {
      const iframeDoc = iframeRef.current.contentDocument || iframeRef.current.contentWindow.document;
      iframeDoc.open();
      iframeDoc.write(content);
      iframeDoc.close();
    }
  };

  const handleSendNewsletter = async () => {
    if (!subject || !htmlContent) {
      setResponseMessage('Please fill in both subject and content.');
      setResponseType('error');
      return;
    }

    setIsSending(true);
    setResponseMessage('');
    setResponseType('');
  
    try {
      const response = await sendNewsletter({ subject, htmlContent });
      if (response.success) {
        setResponseMessage('Newsletter sent successfully!');
        setResponseType('success');
      } else {
        setResponseMessage('Failed to send the newsletter. Please try again.');
        setResponseType('error');
      }
    } catch (error) {
      setResponseMessage('Error sending newsletter. Please try again.');
      setResponseType('error');
    } finally {
      setIsSending(false);
    }
  };

  return (
    <div className={styles.newsletterFormContainer}>
      <h2 className={styles.newsletterFormTitle}>Create Your Newsletter</h2>
      <div className={styles.newsletterFormPreviewWrapper}>
        <div className={styles.newsletterForm}>
          <div className={styles.newsletterTextareaWrapper}>
            <input
              type="text"
              value={subject}
              onChange={handleSubjectChange}
              placeholder="Enter newsletter subject"
              className={styles.newsletterSubjectInput}
            />
          </div>
          <div className={styles.newsletterTextareaWrapper}>
            <textarea
              value={htmlContent}
              onChange={handleHtmlContentChange}
              placeholder="Enter HTML content here"
              className={styles.newsletterHtmlInput}
            />
          </div>
          <button
            onClick={handleSendNewsletter}
            className={`${styles.newsletterSendButton} ${isSending ? styles.sendingAnimation : ''}`}
            disabled={isSending}
          >
            {isSending ? 'Sending...' : 'Send Newsletter'}
          </button>
        </div>
        <div className={styles.newsletterPreviewContainer}>
          <h3 className={styles.newsletterPreviewTitle}>Live Preview</h3>
          <iframe
            ref={iframeRef}
            title="Newsletter Preview"
            className={styles.newsletterIframe}
          />
        </div>
      </div>
      {responseMessage && (
        <div className={`${styles.newsletterResponseMessage} ${styles[`response${responseType.charAt(0).toUpperCase() + responseType.slice(1)}`]}`}>
          {responseMessage}
        </div>
      )}
    </div>
  );
};

export default NewsletterForm;